var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"common-style staff common-sub-app"},[(_vm.host)?_c('iframe',{attrs:{"src":`${_vm.host}/#/staff?showCommonView=0`,"width":"100%","height":"100%","title":"Google"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }